import React, { Component } from "react";
class DarkSide extends Component {
  render() {
    return (
      <section className="col-7 nested">
        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_1.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            The dark side ideation technique is a creative exercise where you
            deliberately ideate for a brief that is the direct opposite of your
            original goal. If your goal is to help people, the goal of the dark
            side is to ruin lives.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_2.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            What you do is take a design brief and flip it.
            <br></br>
            <br></br>
            First you ideate for the opposite of what you were meant to design
            for.
            <br></br>
            <br></br>
            Sit with your ‘dark’ ideations for a bit and then come up with ideas
            for the actual design brief.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_3.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            We all have a dark side to us, don’t we? As designers, our goal is
            to do good, but we can’t be wholesome all the time. So, why not
            embrace the dark and ideate for both sides?
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_4.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            While working on our graduation project for the HCI masters at UCD,
            my team and I worked with Chronic Pain Ireland to support people who
            feel overwhelmed by their pain.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_5.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            After research, we settled on 2 design briefs.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_6.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            And then we flipped them. We first ideated for the “dark side”
            brief, then for the original. That’s 4 distinct design challenges
            from 2 starting points.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_7.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            The dark side ideas our team collected.
            <br></br>
            <br></br>
            This one on top is - “A device that forces you to keep moving and
            electric shocks you when you stop.”
            <br></br>
            <br></br>
            Designing deceptive tech is fun.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_8.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            After indulging our worst impulses, we pivoted to our true goal. The
            ideas we generated were more thoughtful and human-centred.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_9.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            3 out of 4 of the team had a tech background. As techies, we tend to
            think of a solution first and then consider if the solution really
            helps. Dark side let us do what we do best - jump to solutions. But
            also, pause and reflect.
            <br></br>
            <br></br>
            Girl in tears has an art background :(
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_10.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            This technique helped us frame the brief as human problems, not
            ‘tasks to be solved’. One unifying theme in our “dark” designs? We
            all instinctively created the worst user interfaces (UI) imaginable.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_11.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            I don’t know if we would have considered minute UI issues if we
            hadn’t deliberately tried to make it so bad for us users. Dark side
            let us consider the deeper implications behind our designs.
            <br></br>
            <br></br>
            Does this slide have anything to do with UI? Maybe.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_12.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            We realised our ‘good’ ideas often reflected our biases, not user
            needs. We defaulted to tech solutions until the dark side showed us
            how tech could add to the burden of pain.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_13.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            Design, like justice, demands balance. Our dark side ideas revelled
            in cold logic, but getting to know our users let us design with
            empathy in our second phase of design.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_14.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            As researchers, we got to know about the worst issues faced by
            chronic pain patients. At this point, we were sick of feeling bad
            for the people we were designing for.
            <br></br>
            <br></br>
            Going full-on Bond villain evil felt really good. Cathartic, even.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_15.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            It also let us emotionally detach from our users for a second and
            consider how bad design can cause real harm. It let us unflinchingly
            look at people we were designing for, even though it may be hard to
            look.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_16.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            The dark side works because it hijacks our natural problem-solving
            instincts. By first designing against our goals, we surface hidden
            assumptions—like assuming ‘help’ always means ‘more features’.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_17.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            The dark side is both a contradiction and a mirror. It reflects our
            own hubris back at us with brutal clarity.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_18.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            This was the final design.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_19.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            But most of all, do your own thing.
          </p>
        </div>

        <div className="text-group">
          <div className="medium-spacer-bottom small-spacer-top">
            <img
              className="project-image"
              alt="Slides from the Dark Side"
              src={require("../assets/images/darkside/slide_20.png")}
            />
          </div>
        </div>
        <div className="text-group">
          <p className="large-paragraph medium-spacer-bottom col-7">
            I hope your next brief starts with: How might we ruin everything?
          </p>
        </div>
      </section>
    );
  }
}

export default DarkSide;
